import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const HERO_IMG = 'https://cdn.magicpatterns.com/uploads/57Y8FiC3YYebFmDiuQ2R2d/hf_20260315_012328_38fb8058-a30e-48e2-998a-84287ec8d514.jpg';
export function HeroSection() {
  return <section className="relative bg-gradient-to-br from-[#1a0533] via-[#2d1052] to-[#3b1466] pt-20 pb-24 px-4 overflow-hidden" data-id="element-61">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-[#a855f7] opacity-20 blur-[100px] rounded-full pointer-events-none" data-id="element-62"></div>

      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-63">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="text-5xl md:text-7xl font-black text-white mb-8 leading-tight drop-shadow-lg" data-id="element-64">
          🚀 Dominá la Inteligencia Artificial
        </motion.h1>

        {/* LCP image — NO motion wrapper, NO lazy loading, high priority, responsive sizes */}
        <a href="#comprar" className="block max-w-4xl mx-auto mb-10 cursor-pointer group" data-id="element-65">
          <div className="relative rounded-2xl overflow-hidden shadow-[0_0_50px_rgba(168,85,247,0.3)] border border-[#a855f7]/30 transition-transform duration-300 group-hover:scale-[1.02]" data-id="element-66">
            <img src={HERO_IMG} alt="Dominá la Inteligencia Artificial" className="w-full h-auto object-cover" width={1200} height={675} fetchPriority="high" sizes="(max-width: 640px) 100vw, (max-width: 1024px) 90vw, 896px" data-id="element-67" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1a0533]/80 to-transparent" data-id="element-68"></div>
          </div>
        </a>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} data-id="element-69">
          <h2 className="text-2xl md:text-4xl font-bold text-[#FFD700] mb-6 drop-shadow-md" data-id="element-70">
            El curso práctico para crear imágenes, videos, voces y contenido con
            IA
          </h2>

          <div className="inline-block bg-red-600 text-white font-bold px-6 py-2 rounded-full mb-8 animate-pulse text-lg md:text-xl shadow-lg border-2 border-red-400" data-id="element-71">
            ⏳ PRECIO DE LANZAMIENTO
          </div>

          <p className="text-xl md:text-2xl text-[#c4b5d4] max-w-3xl mx-auto mb-10 font-medium leading-relaxed" data-id="element-72">
            Para emprendedores, creadores de contenido y cualquier persona que
            quiera aprovechar el poder de la inteligencia artificial.
          </p>

          <div className="flex flex-col md:flex-row justify-center items-center gap-6 mb-12 text-lg font-semibold text-white" data-id="element-73">
            <div className="flex items-center gap-2 bg-black/30 px-4 py-2 rounded-lg border border-white/10" data-id="element-74">
              <span data-id="element-75">🔓</span> Acceso inmediato
            </div>
            <div className="flex items-center gap-2 bg-black/30 px-4 py-2 rounded-lg border border-white/10" data-id="element-76">
              <span data-id="element-77">💻</span> 100% online
            </div>
            <div className="flex items-center gap-2 bg-black/30 px-4 py-2 rounded-lg border border-white/10" data-id="element-78">
              <span data-id="element-79">♾</span> Acceso de por vida
            </div>
          </div>

          <CTAButton data-id="element-80">🚀 ¡QUIERO DOMINAR LA IA AHORA!</CTAButton>
        </motion.div>
      </div>
    </section>;
}